'use client';

import React from 'react';
import clsx from 'clsx';
import styles from './PersonaliseCapsule.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import Img from '@/components/Img';

type PersonaliseCapsuleProps = {
  data: {
    description?: string;
    button: {
      id: string;
      title: string;
      type: ButtonType;
      link: string;
      iconName: string;
    }[];
    media?: {
      image: {
        url: string;
      };
      css: {
        width: string;
        height: string;
      };
    };
  };
};

const PersonaliseCapsule: React.FC<PersonaliseCapsuleProps> = ({ data }) => (
  <section className={clsx(styles.personaliseCapsule, 'custom')}>
    <div className={clsx(styles.content, 'global-section')}>
      <div className={styles.leftColumn}>
        {data?.description && (
          <p className={styles.text}>{data.description}</p>
        )}
        {data.button.length > 0 && (
          <div className={styles.buttonContainer}>
            {data.button.map((button) => (
              <Button
                type={button.type}
                onClick={() => button.link && window.open(button.link, '_blank')}
                className={styles.primaryButton}
                iconName={button.iconName || 'arrow_forward'}
                key={button.id}
              >
                {button.title}
              </Button>
            ))}
          </div>
        )}
      </div>
      <div className={styles.rightColumn}>
        {data?.media && (
          <Img
            src={data.media.image.url}
            width={200}
            height={120}
            alt='Personalise Capsule'
          />
        )}
      </div>
    </div>
  </section>
);

export default PersonaliseCapsule;
